var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2563EB",
  d: "M25.75 0H6.25A6.25 6.25 0 0 0 0 6.25v19.5A6.25 6.25 0 0 0 6.25 32h19.5A6.25 6.25 0 0 0 32 25.75V6.25A6.25 6.25 0 0 0 25.75 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.25 8c.336 0 .635.215.741.534l3.947 11.84 1.602-4.809.01-.03a.78.78 0 0 1 .731-.504h3.125a.781.781 0 0 1 0 1.563h-2.562L18.68 23.09a.781.781 0 0 1-1.483 0L13.25 11.25l-1.603 4.809a.78.78 0 0 1-.74.534H7.78a.781.781 0 0 1 0-1.563h2.562l2.166-6.497.01-.03A.78.78 0 0 1 13.25 8"
})));
export default SvgLogo;